export const getRewardPointCost = loyalty =>
  loyalty.rewards?.reduce((acc, reward) => {
    if (acc === null || reward.points < acc) {
      return reward.points;
    }

    return acc;
  }, null) || 35;
